import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  iframe: defineAsyncComponent(() => import("/vercel/path0/layouts/iframe.vue").then(m => m.default || m))
}